module.exports = __webpack_public_path__ + "static/media/googlemap.974d0b9b.svg";